import { clientRecords, contractApi, feeApi } from '@atheneum/api'
import { extendObservable, computed } from 'mobx'

class ContractStore {
  constructor (staticData, growlStore) {
    extendObservable(this, {
      staticData,
      growlStore,
      contract: null,
      projects: [],
      projectCount: 0,
      feesLoading: false,
      feesPage: 1,
      fees: [],
      feeOvercharge: null,
      feeCount: 0,
      loading: false,
      error: null,
      isPayg: computed(() => {
        if (!this.contract) return false
        return (
          this.contract.contractTypeId === staticData.CONST.CONTRACT_TYPES.PAYG
        )
      }),
      contractFees: [],
      contractFeesCount: 0
    })
  }

  get (contractId) {
    this.loading = true
    return contractApi
      .getContract(contractId)
      .then(contract => {
        this.contract = contract
        this.loading = false
      })
      .catch(err => {
        this.error = err
      })
  }

  update = contractApi.update

  linkContracts (contractIds, linkReason) {
    return contractApi
      .linkContracts(this.contract.id, contractIds, linkReason)
      .then(contract => {
        this.contract.linkedContracts.replace(contract.linkedContracts)
        return this.contract
      })
      .catch(err => {
        this.error = err
      })
  }

  updateLinkedContracts (contractAId, contractBId, linkReason) {
    return contractApi
      .updateLinkedContracts(contractAId, contractBId, linkReason)
      .then(contract => {
        this.contract.linkedContracts.replace(contract.linkedContracts)
        return this.contract
      })
  }

  unlinkContracts (contractAId, contractBId) {
    return contractApi
      .unlinkContracts(contractAId, contractBId)
      .then(contract => {
        this.contract.linkedContracts.replace(contract.linkedContracts)
        return this.contract
      })
  }

  getAccountContracts (accountId) {
    return contractApi.getAccountContracts(accountId).catch(err => {
      this.error = err
    })
  }

  getProjects (contractId, page, limit) {
    return contractApi.getProjects(contractId, page, limit).then(result => {
      this.projects.replace(result.rows)
      this.projectCount = result.count
      return result.rows
    })
  }

  getAttachments (contractId) {
    return contractApi.getAttachments(contractId).then(attachments => {
      this.contract.attachments.replace(attachments)
      return attachments
    })
  }

  deleteAttachment = fileId => {
    return contractApi.deleteAttachment(fileId).then(() => {
      return this.getAttachments(this.contract.id)
    })
  }

  rolloverCredits (contractId) {
    return contractApi
      .rolloverCredits(this.contract.id, contractId)
      .then(() => this.get(this.contract.id))
  }

  deleteContract (contractId) {
    return contractApi
      .deleteContract(contractId)
      .then(() => {
        this.growlStore.showSuccess('Contract successfully deleted.')
      })
      .catch(error => {
        this.growlStore.showError(error.message)
        throw error
      })
  }

  assignFees ({ contractId, feeIds }) {
    return contractApi.assignFees({ contractId, feeIds })
  }

  getBatchApplicableContracts (feeIds) {
    return contractApi.getBatchApplicableContracts(feeIds)
  }

  getFees = async (page = 1) => {
    this.feesLoading = true
    this.feesPage = page
    const fees = await feeApi.getContractFees(this.contract.id, page)
    this.fees.replace(fees.rows)
    this.feeCount = fees.count
    this.feesLoading = false
    return fees
  }

  getFeeCount = async () => {
    const count = await feeApi.getContractFeesCount(this.contract.id)
    this.feeCount = count
    return count
  }

  getParentAccountContracts (parentAccountId) {
    return clientRecords.getContracts(parentAccountId)
  }
}

export default ContractStore
